import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';


@Component({
  selector: 'app-character-swatch',
  templateUrl: './character-swatch.component.html',
  styleUrls: ['./character-swatch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CharacterSwatchComponent implements OnInit {

  public info!: any;
  private _codePoint: number = -1;
  public item: any;
  public name = '';
  public tagCount = 0;
  public get element(): HTMLDivElement {
    return this.domNode.nativeElement;
  }
  @HostBinding('class.character-swatch') charSwatchClass = true;
  @HostBinding('class.has-data') hasData = false;
  @HostBinding('class.selected') selected = false;
  @HostBinding('class.full-width') fullWidth = false;
  @HostBinding('class.full-height') fullHeight = false;

  @Input() set full(isFull: boolean) {
    this.fullWidth = isFull;
    this.fullHeight = isFull;
    this.cdr.detectChanges;
  }

  @Input() set charInfo(info: any) {
    this.info = info;
    this.Refresh();
  }
  @Input() set codePoint(code: number) {
    if (!this.info) {
      this.info = { code: code };
    }
    this._codePoint = code;
    this.codeText = code.toString(16).padStart(4, '0').toUpperCase();
    this.codeHTML = (code < 0) ? '' : `&#${code};`;
  }
  get codePoint(): number {
    return this._codePoint;
  }
  @Input() set rotation(theta: number) {
    this.domNode.nativeElement.style.setProperty('--symbol-rotation', theta + 'deg');
  }
  @Input() set size(inSize: string | number) {
    this.domNode.nativeElement.style.setProperty('--symbol-size', ''+inSize);
    //this.sizeStyle = inSize;
  }
  @Input() set color(inColor: string) {
    this.colorStyle = inColor;
  }
  @Input() set src(inSwatch: CharacterSwatchComponent) {
    if (!inSwatch) {
      return;
    }
    this.charInfo = inSwatch.info;
    this.Refresh();
  }
  @Input() set font(symbolFont: string) {
    this.domNode.nativeElement.style.setProperty('font-family', symbolFont);
  }
  public get width(): string {
    return this.domNode.nativeElement.offsetWidth + 'px';
  }
  public get height(): string {
    return this.domNode.nativeElement.offsetHeight + 'px';
  }
  public get symbolWidth(): number {
    const nodes = this.domNode.nativeElement.getElementsByClassName('symbol');
    if (nodes.length > 0) {
      return (nodes[0] as HTMLElement).offsetWidth;
    }
    return 0;
  }
  @HostBinding('class.has-name') hasName = false;
  @HostBinding('class.has-tags') hasTags = false;
  @HostBinding('style.color') colorStyle = '#000000';
  @Output() selection = new EventEmitter<CharacterSwatchComponent>();
  @HostBinding('class.selectable') selectableClass = true;
  @Input() set mode(inMode: 'selectable' | 'unselectable') {
    this.selectableClass = inMode === 'selectable';
  }
  public codeText = '';
  public codeHTML = '';
  constructor(private cdr: ChangeDetectorRef, private domNode: ElementRef<HTMLDivElement>) { }

  ngOnInit(): void {
  }
  HandleClick(evt: MouseEvent) {
    evt.stopImmediatePropagation();
    if (!this.selected) {
      this.selected = true;
      this.selection.emit(this);
    }
  }
  Select() {
    this.selected = true;
  }
  DeSelect() {
    this.selected = false;
  }
  Refresh() {
    this.codePoint = -1;
    this.cdr.detectChanges();
    this.codePoint = this.info?.code;

    this.hasName = false;
    this.hasTags = false;
    if (!!this.info?.name) {
      this.name = this.info.name;
      this.hasName = (this.info.name !== this.codeText);
    }
    this.hasData = (this.name !== this.codeText);
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }
}
